import axios from "axios";
import config from "@/App/config";

export const HttpEngine = axios.create({
  baseURL: `${config.API_URL}/admin/v4`,
  headers: {
    common: {
      accept: "application/json",
      Authorization: `JWT ${localStorage.getItem("jwt") || "null"}`
    }
  }
});

export const setDefaultAuthorizationHeader = (authorizationHeader?: string | null) => {
  HttpEngine.defaults.headers.common.Authorization = `JWT ${authorizationHeader}`;
};
